// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"0801d8c8","715":"6c5df418"}[chunkId] + ".chunk.js";
};